<template>
  <AppLayout>
    <VFlex
      sm12
      md12
    >
      <h1 class="primary--text mb-4">
        {{ $nt('heading') }}
      </h1>
      <VCard>
        <VTabs color="white">
          <VTab
            v-for="item in agencySettings"
            :key="item.name"
            :to="{name: item.routeName}"
          >
            {{ item.name }}
          </VTab>
        </VTabs>
        <VDivider />
        <VFlex xs12>
          <RouterView />
        </VFlex>
      </VCard>
    </VFlex>
  </AppLayout>
</template>

<script>
export default {
  name: 'AgencySettings',
  props: [],
  computed: {
    agencySettings () {
      return [
        { name: this.$nt('agencyEdit'), routeName: 'agencyEdit.admin' },
        { name: this.$nt('agencyDisable'), routeName: 'agencyDisable.admin' }
      ]
    }
  }
}
</script>
